module.exports = __webpack_public_path__ + "static/media/home-mockup-1.88c2f8cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/homepage-mock/home-mockup-1.svg
// module id = 1374
// module chunks = 0